import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { getGisIssues } from '../api/gisApi'

import type { GisScope } from '../api/types'

/**
 * District-wide issue feed for the Issues tab (B1 list + B4 breakdown). Keyed by the same scope
 * shape as mandals/trends (period → a concrete date range inside `getGisIssues`). Issues move faster
 * than mandal rollups, so a 1-minute staleTime; `keepPreviousData` stops the list flashing empty on
 * entity/period switches.
 */
export const gisIssuesQueryOptions = (scope: GisScope) =>
  queryOptions({
    queryKey: ['gis', 'issues', scope.period, scope.entityId ?? null, scope.dateFrom ?? null, scope.dateTo ?? null] as const,
    queryFn: () => getGisIssues(scope),
    staleTime: 1000 * 60,
    placeholderData: keepPreviousData,
  })

export function useGisIssues(scope: GisScope) {
  return useQuery(gisIssuesQueryOptions(scope))
}
